import React, { useEffect, useState } from "react";
import { TableWrapper } from "./MyEarnings.styled";
import rightarrow from "../../images/cashbach/arrow-right-s-line1.svg";
import { allCashbackss } from "../../redux/slices/reports/reportsService";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { ReactComponent as InfoIcon } from "../../images/cashbach/red-i-icon.svg";


const MyEarnings: React.FC = () => {
  const dispatch = useDispatch();
  const [approvedCashback, setApprovedCashback] = useState(0);
  const [pendingCashback, setPendingCashback] = useState(0);
  const [showTooltip, setShowTooltip] = useState<number | null>(null);

  const { allCashbacksList } = useSelector(
    (state: any) => state?.reports || {}
  );
  useEffect(() => {
    dispatch(allCashbackss());
  }, []);
  const noOfDays = 30;
  useEffect(() => {
    if (allCashbacksList?.length > 0) {
      let appCash = 0;
      let pendCash = 0;
      allCashbacksList.map((item: any) => {
        const transactionDate = new Date(item.transactionDate);
        const today = new Date();

        const diffInTime = today.getTime() - transactionDate.getTime();
        const diffInDays = diffInTime / (1000 * 3600 * 24);
        if (diffInDays > noOfDays) {
          appCash = appCash + parseFloat(item.commission);
        } else {
          pendCash = pendCash + parseFloat(item.commission);
        }
      });
      setApprovedCashback(appCash);
      setPendingCashback(pendCash);
    }
  }, [allCashbacksList]);



  const totalCommission = Array.isArray(allCashbacksList)
  ? allCashbacksList.reduce(
      (total: number, row: any) => total + (parseFloat(row.commission) || 0),
      0
    )
  : 0;


  return (
    <TableWrapper>
      <div
      className="backbutton-sec"
      onClick={() => {
        window.history.back();
      }}
      >
      <img src={rightarrow} alt="rightarrow" />
      Atrás
      </div>
      <div className="sectionwrapper">
      <h1>Mis Ganancias</h1>
      <p>Tus ganancias se mostrarán aquí</p>
      <div className="cashback-balance-div">
        <p className="text">
        Saldo Total de Cashback:{" "}
        <span className="amount-sec-val amount-sec-val1">
          {`COP $${Number(totalCommission.toFixed(2))}`}
        </span>
        </p>
        <p className="text">
        Cashback pagado:{" "}
        <span className="amount-sec-val amount-sec-val2">
          {`COP $${Number(approvedCashback.toFixed(2))}`}
        </span>
        </p>
        <p className="text">
        Cashback pendiente:{" "}
        <span className="amount-sec-val amount-sec-val3">
          {`COP $${Number(pendingCashback.toFixed(2))}`}
        </span>
        </p>
      </div>
      <table>
        <thead>
        <tr>
          <th>Fecha de Transacción</th>
          <th>Nombre del Comerciante</th>
          <th>Monto de la Transacción</th>
          <th>Cashback Ganado</th>
          <th>Estado</th>
        </tr>
        </thead>
        <tbody>
        {Array.isArray(allCashbacksList) &&
          allCashbacksList.map((row: any, index: number) => {
          const transactionDate = new Date(row.transactionDate);
          const today = new Date();

          const diffInTime = today.getTime() - transactionDate.getTime();
          const diffInDays = diffInTime / (1000 * 3600 * 24);

          const status = diffInDays > noOfDays ? "Cashback pagado" : "Pendiente";

          return (
            <tr key={index}>
            <td>{moment(row.transactionDate).format("YYYY-MM-DD")}</td>
            <td>{row.merchantName}</td>
            <td>{`COP $${Number(row.transactionAmount.toFixed(2))}`}</td>
            <td>{`COP $${Number(row.commission.toFixed(2))}`}</td>
            <td className={`status-${status}`}>
              {status}
              {status === "Pendiente" && (
              <>
              <InfoIcon
                className="info-icon"
                onClick={() => setShowTooltip((prev) => (prev === index ? null : index))}
              />
              {showTooltip === index && (
                <div className="tooltiptext">
                El cashback pendiente será pagado en 30-45 días por
                tu banco una vez que recolectemos el cashback del
                comerciante donde realizaste tu compra.
                </div>
              )}
              </>
              )}
            </td>
            </tr>
          );
          })}
        </tbody>
      </table>
      </div>
    </TableWrapper>
  );
};

export default MyEarnings;
